<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("propertyInOutLogs") }}</div>
      </div>
    </div>
    <br />

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <multiselect
                v-model="selectedCinema"
                label="cine_name"
                track-by="cine_id"
                :placeholder="$t('Cinema')"
                :options="Cinemas"
                @select="onSelectCinema($event)"
                @remove="onSelectCinema($event, 'remove')"
              >
                <span slot="noResult">Oops! No Results found.</span>
              </multiselect>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-2 align-self-center mb-2">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                @click="fromDate = null"
                class="btn-clearDate"
                v-if="fromDate"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                v-model="fromDate"
                typeable
              ></Datepicker>
              <label :class="fromDate ? 'active' : ''">{{ $t("date") }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-xl-2 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <multiselect
                v-model="selectedType"
                label="type"
                track-by="type_id"
                :placeholder="'Select Action'"
                :options="TypeList"
                @select="onSelectType($event, 'select')"
                @remove="onSelectType($event, 'remove')"
              >
                <span slot="noResult">Oops! No Results found.</span>
              </multiselect>
            </div>
          </div>
        </div>

        <div class="col-3">
          <b-form-input
            v-debounce:600="getPropertyInOutLogs"
            v-model="searchValue"
            type="search"
            placeholder="Search..."
          ></b-form-input>
        </div>

        <div class="col-md-2">
          <button class="btn-blue" @click.prevent.stop="getPropertyInOutLogs()">
            {{ $t("fetch") }}
          </button>
        </div>

        <div class="d-flex align-items-center justify-content-end w-100">
          <div
            v-if="propertyInOutLogs.length > 0"
            class="align-self-center mb-1 d-flex justify-content-end align-items-center"
          >
            <div>{{ $t("download") }} as:</div>
            <a
              target="_blank"
              download
              title="Download as PDF"
              @click="getPropertyInOutLogs(`PDF`)"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              title="Download as Excel"
              @click="getPropertyInOutLogs(`excel`)"
            >
              <img
                class="mx-2"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <!-- LIST VIEW DESIGNATION -->
      <div class="swc-report mt-2">
        <table class="swc-report-table">
          <thead class="tableHeaderSticky">
            <tr class="bg-lightgrey">
              <th>{{ "Code" }}</th>
              <th>{{ $tc("rawmaterials", 2) }}</th>
              <th>{{ "Rate" }}</th>
              <th>{{ "Qty" }}</th>
              <th>{{ "UOM" }}</th>
              <th>{{ "Type" }}</th>
              <th>{{ "Date" }}</th>
              <th>{{ "Created By" }}</th>
              <th>{{ $t("remarks") }}</th>
              <th>{{ "Total Value" }}</th>
            </tr>
          </thead>
          <tbody v-if="propertyInOutLogs.length > 0">
            <tr v-for="(log, logIndex) in propertyInOutLogs" :key="logIndex">
              <td>{{ log.pio_order_no || "-" }}</td>
              <td>{{ log.rm_name || "-" }}</td>
              <td>
                {{
                  parseFloat(log.purchase_rate || 0).toFixed(
                    MIN_FRACTION_DIGITS
                  )
                }}
              </td>
              <td>
                {{ parseFloat(log.qty || 0).toFixed(MIN_FRACTION_DIGITS) }}
              </td>
              <td>{{ log.uom_short_form || "-" }}</td>
              <td>{{ log.type || "-" }}</td>
              <td>{{ log.created_at }}</td>
              <td>{{ log.username || "-" }}</td>
              <td>{{ log.remarks || "-" }}</td>
              <td>
                {{
                  parseFloat(log.total_in_out_value || 0).toFixed(
                    MIN_FRACTION_DIGITS
                  )
                }}
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <td>Total</td>
              <td></td>
              <td>
                {{
                  parseFloat(
                    propertyInOutLogs.reduce(
                      (acc, { purchase_rate }) =>
                        acc + parseFloat(purchase_rate),
                      0
                    )
                  ).toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
              <td>
                {{
                  parseFloat(
                    propertyInOutLogs.reduce(
                      (acc, { qty }) => acc + parseFloat(qty),
                      0
                    )
                  ).toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                {{
                  parseFloat(
                    propertyInOutLogs.reduce(
                      (acc, { total_in_out_value }) =>
                        acc + parseFloat(total_in_out_value),
                      0
                    )
                  ).toFixed(MIN_FRACTION_DIGITS)
                }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="9">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService";
import MasterService from "@/services/MasterService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      submitted: false,
      Cinemas: [],
      selectedCinema: "",
      cinema_id: null,
      type_id: null,
      selectedType: null,
      fromDate: new Date(),
      propertyInOutLogs: [],
      PdfPath: null,
      ExcelPath: null,
      searchValue: "",
      TypeList: [
        {
          type_id: 1,
          type: "IN",
        },
        {
          type_id: 2,
          type: "OUT",
        },
      ],
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    if (true) {
      this.getCinemas(obj);
    }
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.selectedCinema = CinemaObj;
      this.cinema_id = CinemaObj.cine_id;
      this.fromDate = new Date();
      this.getPropertyInOutLogs();
    }
  },
  mounted() {},
  methods: {
    onSelectType(event, type) {
      if (type == "remove") {
        this.selectedType = null;
        this.type_id = null;
      } else {
        this.selectedType = event;
        this.type_id = event.type_id;
      }
    },
    getCinemas: function (cine_id) {
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onSelectCinema(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectCinema: function (params) {
      this.selectedCinema = params;
      this.cinema_id = params.cine_id;
      this.$store.dispatch("selectDropdownCinema", params);
    },
    getPropertyInOutLogs: function (action = "") {
      if (!this.cinema_id) {
        return this.$toasted.show("Please Select Cinema");
      } else if (!this.fromDate) {
        return this.$toasted.show("Please Select Date");
      } else {
        let loader = this.$loading.show();
        PosFnbService.GetPropertyInOutAuditLogs({
          cinema_id: this.cinema_id,
          fromDate: this.fromDate,
          type_id: this.type_id,
          searchValue: this.searchValue,
          isExcelDownload: action == "excel" ? "Y" : "N",
          isPdfDownload: action == "PDF" ? "Y" : "N",
        })
          .then((response) => {
            const { data } = response;
            if (
              data &&
              data.status &&
              data.hasOwnProperty("excelPath") &&
              data.excelPath &&
              action == "excel"
            ) {
              window.open(data.excelPath, "_blank");
            } else if (
              data &&
              data.status &&
              data.hasOwnProperty("pdfPath") &&
              data.pdfPath &&
              action == "PDF"
            ) {
              window.open(data.pdfPath, "_blank");
            } else if (
              data &&
              data.status &&
              data.hasOwnProperty("Records") &&
              data.Records &&
              data.Records.length
            ) {
              this.propertyInOutLogs = data.Records || [];
            } else {
              this.propertyInOutLogs = [];
              this.$toasted.show(data.message || "No Records Found");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
            this.propertyInOutLogs = [];
            this.$toasted.show("Error");
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
  },
};
</script>

<style scoped>
.swc-report-table th,
.swc-report-table td {
  border: 1px solid #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/PropertyInOutComponents/propertyInOutAuditLogs.vue